import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppState } from '../../../reducers';
import { login } from '../state/auth.actions';
import { catchError, tap } from 'rxjs/operators';
import { noop, Observable, of } from 'rxjs';

import { AuthService } from '../service/auth.service';
import { AppComponent } from 'src/app/app.component';
import { Msg, UserToken } from '../model/user.model';
import { HelperService } from 'src/app/service/helper.service';
import { RegionService } from '../../common-components/region/service/region.service';
import { TrackingType, Route } from 'src/app/model/session-tracking/tracking-type';
import { DatePipe } from '@angular/common';
import { HelpTextService } from '../../common-components/help-text/service/help-text.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    form: UntypedFormGroup;
    hide = true;
    hideLoginPanel: boolean = false;
    isLoading: boolean = false;

    msg: Msg = new Msg();
    latestBuildDateTime: string = '';
    constructor(
        private fb: UntypedFormBuilder,
        private auth: AuthService,
        private router: Router,
        private helperService: HelperService,
        private datePipe: DatePipe,
        private store: Store<AppState>,
        private helpTextService: HelpTextService
    ) {
        this.form = fb.group({
            username: ['', [Validators.required]],
            password: ['', [Validators.required]]
        });
        //Display Build Info
        this.helpTextService.getBuildVersion().subscribe((buildDate: BuildVersion | null) => {
            this.latestBuildDateTime = buildDate?.updatedAt || '';
        });
    }

    ngOnInit(): void {}

    login() {
        this.isLoading = true;
        const val = this.form.value;
        this.auth
            .login(val.username, val.password)
            .pipe(
                tap((userToken) => {
                    if (userToken?.token) {
                        this.form.setErrors({ loginFailed: false });

                        this.store.dispatch(login({ userToken }));
                        this.hideLoginPanel = true;
                    } else {
                        this.form.setErrors({ loginFailed: true });
                    }
                    this.isLoading = false;
                })
            )
            .subscribe((res) => {
                this.isLoading = false;
                if (res['msg']) {
                    this.msg = res['msg'];
                }
            });
    }

    toggleHide() {
        this.hide = !this.hide;
    }
}
export interface BuildVersion {
  workflowId: number
  updatedAt: string
}
